export const LOCAL_JSON_DATA_DIR = './priceData'
